<template>
  <section v-if="loaded === this.user.links.length">
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="searchingGroup"
    >
      <GroupPreview :groupInfo="groupPreview" />
    </div>
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="isEditingProfile"
    >
      <div class="interestBox">
        <EditProfile :profile="profile" />
      </div>
    </div>

    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="isEditingInterest"
    >
      <div class="interestBox">
        <AddInterests
          :selectedInterests="profile.interests"
          :isProfile="true"
          :maxInterests="5"
        />
      </div>
    </div>

    <Navbar />
    <div>
      <div id="backBoxProfile">
        <div class="flexBigRight">
          <div
            id="middleColumn"
            :class="{ isWindow: isWindows }"
            style="margin-left: 5px"
          >
            <div class="profileInfo">
              <div id="profileHeader">
                <div class="profileImage">
                  <img
                    class="profilePicItself"
                    :src="this.profile.profileImage"
                    alt="profile Image"
                  />
                  <!--vue-dropzone
                    ref="imgDropZone"
                    id="profile-pic"
                    :include-styling="false"
                    :options="dropzoneOptions"
                    @vdropzone-complete="setImage"
                  ></vue-dropzone-->
                </div>
                <div id="headerInformation">
                  <div
                    style="
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;
                    "
                  >
                    <p v-if="this.profile && !isEditingName" class="nameDesign">
                      {{ this.profile.firstName }} {{ this.profile.lastName }}
                    </p>
                    <div
                      v-if="isEditingName"
                      class="editing"
                      style="display: flex"
                    >
                      <input
                        type="text"
                        id="fname"
                        name="fname"
                        v-model="firstName"
                      />
                      <input
                        type="text"
                        id="lname"
                        name="lname"
                        v-model="lastName"
                      />

                      <button class="passwordButton" @click="saveName()">
                        Save
                      </button>
                      <p class="feedback">{{ this.feedback }}</p>
                    </div>
                    <button
                      @click="toggleProfile"
                      class="editProfileButton"
                    ></button>
                    <!--p class="spaceLeft nameDesign" v-if="this.clips && this.clips != 0 && !isEditingName">{{ this.clips }} clips</p>
                    <p class="nameDesign" v-else-if="!isEditingName">0 clips</p-->
                  </div>
                  <div id="userMajor">
                    <div style="display: flex; align-items: center">
                      {{ this.profile.year }} - {{ this.profile.major }}
                    </div>
                  </div>
                  <div style="display: flex; align-items: center">
                    <p v-if="this.profile.bio">{{ this.profile.bio }}</p>
                    <p v-else>Add a bio</p>
                  </div>
                </div>
              </div>
              <div id="additionalInfo">
                <div id="interestList">
                  <div class="topPadding" v-if="numInterests == 0">
                    Add Interests
                  </div>
                  <div
                    v-for="(interest, index) in profile.interests"
                    :key="index"
                  >
                    <Interest
                      :icon="interest.unicode"
                      :interest="interest.name"
                    />
                  </div>
                  <button
                    @click="toggleInterest"
                    class="editProfileButton"
                  ></button>
                </div>
                <!-- INTERESTS -->
              </div>
              <div
                class="photoPamphlet"
                :class="
                  profile.images.length < 3
                    ? 'pamphletLeftAlign'
                    : 'pamphletCenterAlign'
                "
              >
                <div
                  class="photoBox"
                  v-for="(image, index) in profile.images"
                  :key="index"
                  draggable
                  @dragstart="startDrag($event, image, index)"
                  @drop="onDrop($event, image, index)"
                  @dragenter.prevent
                  @dragover.prevent
                >
                  <div class="deletePhoto" @click="deleteImage(image)"></div>
                  <img class="profilePhoto" :src="image" />
                  <div class="photoHover"></div>
                </div>
                <div v-if="profile.images.length < 4">
                  <vue-dropzone
                    ref="imgDropZone"
                    id="addPhoto"
                    class="photoBox"
                    :include-styling="false"
                    :options="dropzoneOptions"
                    @vdropzone-complete="addImage"
                  ></vue-dropzone>
                </div>
              </div>
            </div>

            <div v-if="this.taskCounter > 0" class="profileInfo">
              <div class="profileTitles" style="border: none">Progress</div>
              <div class="backgroundProgress">
                <div class="doneBar"></div>
                <div class="separator"></div>
                <div :class="taskCounter > 4 ? 'continueBar' : 'doneBar'"></div>
                <div class="separator"></div>
                <div :class="taskCounter > 3 ? 'continueBar' : 'doneBar'"></div>
                <div class="separator"></div>
                <div :class="taskCounter > 2 ? 'continueBar' : 'doneBar'"></div>
                <div class="separator"></div>
                <div :class="taskCounter > 1 ? 'continueBar' : 'doneBar'"></div>
                <div class="separator"></div>
                <div :class="taskCounter > 0 ? 'continueBar' : 'doneBar'"></div>
              </div>
              <SliderFrame id="nextTaskBox">
                <div slot-scope="{ next, prev }">
                  <SliderSlides>
                    <SliderSlide v-if="hasProfileImg">
                      <div class="nextTask">
                        <img class="taskImage" :src="progressProfileIcon" />
                        <div class="progressText">
                          <p class="progressTitle">Take it and frame it!</p>
                          <p>
                            Having a display picture makes your profile so much
                            more fun to look at
                          </p>
                        </div>
                      </div>
                    </SliderSlide>
                    <SliderSlide v-if="hasInterests">
                      <div class="nextTask">
                        <img class="taskImage" :src="progressInterestIcon" />
                        <div class="progressText">
                          <p class="progressTitle">Love something? Share it!</p>
                          <p>
                            With interests you can find likeminded people and
                            groups
                          </p>
                        </div>
                      </div>
                    </SliderSlide>
                    <SliderSlide v-if="hasBio">
                      <div class="nextTask">
                        <img class="taskImage" :src="progressBioIcon" />
                        <div class="progressText">
                          <p class="progressTitle">
                            Create a bio to tell your life story
                          </p>
                          <p>
                            Use this great opportunity to talk about yourself!
                          </p>
                        </div>
                      </div>
                    </SliderSlide>
                    <SliderSlide v-if="hasImages">
                      <div class="nextTask">
                        <img class="taskImage" :src="progressImageIcon" />
                        <div class="progressText">
                          <p class="progressTitle">
                            Add profile images to show off who you are
                          </p>
                          <p>
                            Images can help others get to know you better
                          </p>
                        </div>
                      </div>
                    </SliderSlide>
                    <SliderSlide v-if="hasGroups">
                      <div class="nextTask">
                        <img class="taskImage" :src="progressGroupIcon" />
                        <div class="progressText">
                          <p class="progressTitle">
                            Join or start a conversation
                          </p>
                          <p>
                            Almost done! Join a group and you're good to go
                          </p>
                        </div>
                      </div>
                    </SliderSlide>
                    <SliderSlide v-if="hasFriends">
                      <div class="nextTask">
                        <img class="taskImage" :src="progressFriendIcon" />
                        <div class="progressText">
                          <p class="progressTitle">Add some friends</p>
                          <p>
                            CourseLnk is a lot more fun when you can interact
                            with friends!
                          </p>
                        </div>
                      </div>
                    </SliderSlide>
                  </SliderSlides>
                  <div class="taskButtonRow">
                    <div class="taskButtons" @click="prev">
                      previous
                    </div>
                    <div class="taskButtons" @click="next">next</div>
                  </div>
                </div>
              </SliderFrame>
            </div>

            <div class="singleList">
              <div class="profileTitles">Courses</div>
              <div
                class="viewBox"
                :class="{ centeredBox: profile.courses.length > 4 }"
              >
                <div
                  class="groupText"
                  v-for="(course, index) in user.courses"
                  :key="index"
                  @click="searchCourse(course.id, course.type)"
                >
                  <div class="eachCourse">
                    <img :src="course.profileImage" alt="" class="courseImg" />
                    <p class="courseNames">{{ course.name }}</p>
                  </div>
                </div>
                <div v-if="user.courses.length < 1" class="noBox">
                  <img
                    class="joinIcon"
                    src="@/assets/Icons/JoinCoursesIcon.svg"
                  />
                  <b style="font-size: 20px; color: black"
                    >Join some courses!</b
                  >
                  <p style="font-size: 14px">
                    We have course chats for every class you're in!
                  </p>
                </div>
              </div>
            </div>
            <div class="singleList">
              <div class="profileTitles">Groups</div>
              <div
                class="viewBox"
                :class="{ centeredBox: user.groups.length > 4 }"
              >
                <div
                  class="groupText"
                  v-for="(group, index) in user.groups"
                  :key="index"
                  @click="searchCourse(group.id, group.type)"
                >
                  <div class="eachCourse">
                    <img :src="group.profileImage" alt="" class="courseImg" />
                    <p class="courseNames">{{ group.name }}</p>
                  </div>
                </div>
                <div v-if="user.groups.length < 1" class="noBox">
                  <img
                    class="joinIcon"
                    src="@/assets/Icons/JoinGroupsIcon.svg"
                  />
                  <b style="font-size: 20px; color: black">Join some groups!</b>
                  <p style="font-size: 14px">
                    Join and create interest, extracurricular, or any other
                    groups you want!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <LightBox ref="lightbox" :media="media" :show-light-box="false" />
        </div>
        <div class="profileFriendList">
          <div class="friendListBox" :class="{ isWindow: isWindows }">
            <div class="profileTitles">Friends</div>
            <div
              class="viewBox"
              :class="{ centeredBoxBig: friendInfo.length > 2 }"
            >
              <div
                class="profileText"
                v-for="(friend, index) in friendInfo"
                :key="index"
                @click="searchFriend(friend.name)"
              >
                <div class="eachCourse">
                  <div class="eachCourseRight">
                    <img :src="friend.profileImage" alt="" class="friendImg" />
                    <div>
                      <p class="courseNames">
                        {{ friend.name }}
                      </p>
                      <p class="mutualList">{{ friend.mutuals }} mutuals</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="noBox" v-if="!friendInfo.length">
                <img class="joinIcon" src="@/assets/Icons/AddFriendsIcon.svg" />
                <b style="font-size: 20px; color: black">Add some friends!</b>
                <p style="font-size: 14px">
                  Find friends using the search bar, discover page, or invite
                  them!
                </p>
                <div class="flexRow">
                  <div class="flexCol"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import { mapState, mapActions } from "vuex";
import SliderFrame from "../../components/sliderFiles/SliderFrame";
import SliderSlide from "../../components/sliderFiles/SliderSlide.vue";
import SliderSlides from "../../components/sliderFiles/SliderSlides.vue";
import db from "@/db";
import firebase from "@/firebase";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
//import Groups from "@/components/Groups";
import LightBox from "vue-image-lightbox";
import moment from "moment";
//import Upcoming from "@/components/profile/Upcoming";
//import Request from "@/components/profile/Request";
import AddInterests from "@/components/profile/AddInterests";
import Interest from "@/components/profile/Interest";
//import SearchBar from "@/components/SearchBar";
import Navbar from "@/components/Navbar";
import EditProfile from "@/components/profile/EditProfile";
import GroupPreview from "@/components/group/GroupPreview.vue";
export default {
  components: {
    vueDropzone: vue2Dropzone,
    //Groups,
    LightBox,
    //Upcoming,
    //Request,
    AddInterests,
    Interest,
    SliderFrame,
    SliderSlide,
    SliderSlides,
    //SearchBar,
    EditProfile,
    Navbar,
    GroupPreview,
  },
  data: () => ({
    media: [], //Clickable images in a post
    profile: [],
    images: [],
    email: null,
    school: null,
    isEditingName: false,
    isEditingMajor: false,
    isEditingBio: false,
    changedPassword: false,
    firstName: "",
    lastName: "",
    feedback: "",
    clips: 0,
    clippedPostIds: [],
    clippedPosts: [],
    isShowingClippedPosts: false,
    currentUser: null,
    currentNotif: "all",
    all: [],
    upcomingEvents: [],
    linkRequests: [],
    chats: [],
    curWeek: moment().week(),
    nextWeek: moment().week() + 1,
    courses: [],
    courseInfo: [],
    groupList: [],
    friendInfo: [],
    isWindows: false,
    year: "Select Year and Major",
    major: "",
    majorCharLeft: 60,
    bio: "",
    bioCharLeft: 130,
    interests: [],
    numImage: 0,
    numInterests: 0,
    dragImage: "",
    dragIndex: 0,
    taskCounter: 0,
    hasProfileImg: false,
    hasInterests: false,
    hasBio: false,
    hasImages: false,
    hasGroups: false,
    hasFriends: false,
    progressProfileIcon:
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FaddDPProgress.png?alt=media&token=11206538-eff2-4d4b-a0a8-345dcee37123",
    progressInterestIcon:
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FaddInterestsProgress.png?alt=media&token=b5cf65a6-cf72-4177-bd0c-958bc24ba252",
    progressBioIcon:
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FaddBioProgressNew.png?alt=media&token=c6e363c3-6a53-4b6a-94b6-b0a3f9e1cf3e",
    progressImageIcon:
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FaddImagesProgress.png?alt=media&token=86ebaaaa-e940-4d7c-ad6a-9e9a5370023f",
    progressGroupIcon:
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FjoinGroupProgress.png?alt=media&token=4283e362-d372-4247-a358-017faac84643",
    progressFriendIcon:
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FprogressAddFriend.png?alt=media&token=5b0a3810-0d49-4cec-a253-08a9a72bd0d3",
    taskIndex: 0,
    tasks: [],
    image: "",
    imageUrl: "",
    //Drop zone options
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      maxFilesize: 5,
      maxFiles: 10,
      duplicateCheck: true,
      addRemoveLinks: true,
      dictDefaultMessage: "Edit Image",
      previewsContainer: false,
    },
    loaded: 0,
  }),
  props: {
    externalUrl: {},
  },
  created() {
    if (!this.user.links) {
      this.user.links = [];
    }
    this.profile.images = [];
    this.profile.courses = [];
    this.initProfile();
    this.currentUser = this.user;
    this.loadImage();
    //this.profile = this.user;
    this.profile.interests = this.profile.interests
      ? this.profile.interests
      : [];
    this.numInterests = this.profile.interests
      ? this.profile.interests.length
      : 0;
    this.setTasks();

    this.fetchFriendInfo();
    window.addEventListener;
    this.isWindows = this.checkOS();
  },
  mounted() {
    this.getIOS();
    this.checkFriendsAndGroups();
    //this.personal();
    /*
    this.fetchCourseInfo();
    this.fetchGroupInfo();
    this.fetchFriendInfo();
    this.fetchUpcoming();
    */
  },
  watch: {
    major() {
      this.majorCharLeft = 60 - this.major.length;
    },
    bio() {
      this.bioCharLeft = 130 - this.bio.length;
    },
    isEditingInterest() {
      this.initProfile();
    },
    isEditingProfile() {
      this.initProfile();
    },
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("messageBoard", [
      "groupId",
      "groupName",
      "searchingGroup",
      "groupPreview",
    ]),
    ...mapState("profile", ["isEditingProfile", "isEditingInterest"]),
  },
  methods: {
    ...mapActions("user", ["logout"]),
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },

    getIOS() {
      if (this.iOS()) {
        window.location.replace("courselnk.com");
      }
    },

    // async personal() {
    //   db.collection("users")
    //     .where("course_id", "==", "NcZfa5GYSOPCWk3J6v6g")
    //     .limit(1)
    //     .get()
    //     .then(function (querySnapshot) {
    //       querySnapshot.forEach(function (doc) {
    //         console.log(doc.data, "data");
    //         doc.ref.delete();
    //       });
    //     });
    // },
    checkOS() {
      if (navigator.appVersion.indexOf("Win") != -1) {
        return true;
      }
      return false;
    },
    logoutClicked() {
      this.logout();
      this.$router.push({ name: "Login" });
    },
    async initProfile() {
      await db
        .collection("users")
        .doc(this.user.id)
        .get()
        .then((doc) => {
          this.profile = doc.data();
          this.user.profileImage = doc.data().profileImage;
          this.user.firstName = doc.data().firstName;
          this.user.lastName = doc.data().lastName;
          this.user.interests = doc.data().interests;

          if (!this.profile.images) {
            this.profile.images = [];
          }
          this.firstName = doc.data().firstName;
          this.lastName = doc.data().lastName;
          this.clips = doc.data().totalClips;
          this.clippedPostIds = doc.data().clips;
          if (doc.data().year) {
            this.year = doc.data().year;
            this.major = doc.data().major;
            this.user.year = doc.data().year;
            this.user.major = doc.data().major;
          }
          if (doc.data().bio) {
            this.bio = doc.data().bio;
            this.user.bio = doc.data().bio;
          }
          this.interests = doc.data().interests;
          this.$store.commit("user/setUser", this.user);
          this.fetchRequests(this.profile.linkRequests);
          db.collection("schools")
            .doc(doc.data().school_id)
            .get()
            .then((doc) => {
              this.school = doc.data().name;
            });
        });
      this.numImage = this.profile.images.length;
      if (this.profile.interests) {
        this.numInterests = this.profile.interests.length;
      } else {
        this.numInterests = 0;
      }

      this.email = firebase.auth().currentUser.email;
    },
    cancelPreview(event) {
      if (event.target.className == "previewContainer") {
        this.$store.commit("messageBoard/setSearchGroup", false);
        this.$store.commit("messageBoard/setCreateGroup", false);
        this.$store.commit("profile/setIsEditingProfile", false);
        this.$store.commit("profile/setIsEditingInterest", false);
        this.$store.commit("profile/setInterests", []);
      }
    },
    searchCourse(id, type) {
      this.$store.commit("messageBoard/setGroupPreview", []);
      this.$store.commit("messageBoard/setSearchGroup", false);
      db.collection(type)
        .doc(id)
        .get()
        .then((doc) => {
          var previewCourse = doc.data();
          previewCourse.type = type;
          previewCourse.id = id;
          this.$store.commit("messageBoard/setGroupPreview", previewCourse);
          this.$store.commit("messageBoard/setSearchGroup", true);
        });
    },
    searchFriend(name) {
      var userName = name.replace(" ", "-");
      this.$router.replace({
        name: "PublicProfile",
        params: { userName: userName },
      });
    },
    routeChange(userName) {
      this.$router.replace({
        name: "PublicProfile",
        params: { userName: userName },
      });
    },
    async fetchClippedPosts() {
      // if (this.clippedPosts.length == 0) {
      //   for (const index in this.clippedPostIds) {
      //     await db
      //       .collection("posts")
      //       .doc(this.clippedPostIds[index])
      //       .get()
      //       .then((doc) => {
      //         this.clippedPosts.push(doc.data());
      //       });
      //   }
      // }
      // this.isShowingClippedPosts = !this.isShowingClippedPosts;

      db.collection("courses")
        .where("school_id", "==", "5Uo24jSg4nGg3sVOzeec")
        .limit(10)
        .get()
        .then((doc) => {
          console.log(doc.data());
        });
      // const objects = [
      //   {
      //     objectID: "myID1",
      //     firstname: "Jimmie",
      //     lastname: "Barninger",
      //   },
      //   {
      //     objectID: "myID2",
      //     firstname: "Warren",
      //     lastname: "Speach",
      //   },
      // ];

      // index.saveObjects(objects).then(({ objectIDs }) => {
      //   console.log(objectIDs);
      // });
    },
    async saveName() {
      if (this.firstName.length + this.lastName.length > 29) {
        this.feedback = "Name must be under 30 characters";
        return;
      }
      if (this.firstName.length > 0 && this.lastName.length > 0) {
        await db
          .collection("users")
          .doc(firebase.auth().currentUser.uid)
          .update({
            firstName: this.firstName,
            lastName: this.lastName,
          });
        this.profile.firstName = this.firstName;
        this.profile.lastName = this.lastName;
        this.isEditingName = false;
      } else if (this.profile.firstName.length == 0) {
        this.feedback = "You must enter a first name";
      } else {
        this.feedback = "You must enter a last name";
      }
    },
    async saveMajor() {
      if (this.major.length > 0) {
        await db
          .collection("users")
          .doc(firebase.auth().currentUser.uid)
          .update({
            year: this.year,
            major: this.major,
          });
        this.isEditingMajor = false;
      } else {
        this.feedback = "You must enter a major";
      }
    },
    async saveBio() {
      if (this.bio.length > 0) {
        await db
          .collection("users")
          .doc(firebase.auth().currentUser.uid)
          .update({
            bio: this.bio,
          });
        this.isEditingBio = false;
      } else {
        this.feedback = "You must enter a bio";
      }
    },
    async setImage(file) {
      const storageRef = firebase.storage().ref();
      // If is an image
      if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
        const fileRef = storageRef.child(`profileImages/${file.name}.png`);
        await fileRef.put(file);
        const downloadURL = await fileRef.getDownloadURL();
        await db
          .collection("users")
          .doc(firebase.auth().currentUser.uid)
          .update({
            profileImage: downloadURL,
          });
        this.profile.profileImage = downloadURL;
      }
    },
    async addImage(file) {
      const storageRef = firebase.storage().ref();
      // If is an image
      if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
        const fileRef = storageRef.child(`profileImages/${file.name}.png`);
        await fileRef.put(file);
        const downloadURL = await fileRef.getDownloadURL();
        this.profile.images.push(downloadURL);

        if (!this.user.progressBar.photos) {
          await db
            .collection("users")
            .doc(firebase.auth().currentUser.uid)
            .update({
              images: this.profile.images,
              progressBar: {
                addFriend: this.user.progressBar.addFriend,
                bio: this.user.progressBar.bio,
                interests: this.user.progressBar.interests,
                joinGroup: this.user.progressBar.joinGroup,
                photos: true,
                profileImage: this.user.progressBar.profileImage,
              },
            });
        } else {
          await db
            .collection("users")
            .doc(firebase.auth().currentUser.uid)
            .update({
              images: this.profile.images,
            });
        }
      }
    },
    async deleteImage(file) {
      const index = this.profile.images.indexOf(file);
      this.profile.images.splice(index, 1);
      await db
        .collection("users")
        .doc(firebase.auth().currentUser.uid)
        .update({
          images: this.profile.images,
        });
    },
    resetPassword() {
      var auth = firebase.auth();
      var emailAddress = this.email;
      auth
        .sendPasswordResetEmail(emailAddress)
        .then(() => {
          this.changedPassword = true;
        })
        .catch(() => {
          this.feedback = "The email entered is not valid";
        });
    },
    openGallery(index, files) {
      this.media = [];
      for (const file in files) {
        const fi = {
          thumb: files[file].src,
          src: files[file].src,
        };
        this.media.push(fi);
      }
      this.$refs.lightbox.showImage(index);
    },
    toggleNotif(current) {
      this.currentNotif = current;
    },
    toggleProfile() {
      this.$store.commit("profile/setIsEditingProfile", true);
      console.log(this.isEditingProfile);
      //this.initProfile();
    },
    toggleInterest() {
      this.$store.commit("profile/setIsEditingInterest", true);
      //this.initProfile();
    },
    createEvent(event) {
      var color = "";
      switch (event.type) {
        case "class":
          color = "#16a085";
          break;
        case "assessment":
          color = "#e74c3c";
          break;
        case "assignment":
          color = "#f39c12";
          break;
        case "office":
          color = "#0984e3";
          break;
        case "other":
          color = "#a55eea";
          break;
      }
      return {
        title: event.title,
        startDate: moment(event.startDate).format("MMM DD, YYYY"),
        endDate: moment(event.startDate).format("MMM DD, YYYY"),
        daysLeft: Math.floor(
          moment(event.endDate).format("DD") - moment().format("DD")
        ),
        type: "Calendar",
        color: color,
      };
    },
    fetchUpcoming() {
      this.user.courses.forEach((course) =>
        db
          .collection("calendarEvents")
          .where("group_id", "==", course.course_id)
          .where("weeks", "array-contains-any", [this.curWeek, this.nextWeek])
          .orderBy("startDate", "asc")
          .onSnapshot((calendarEvents) => {
            this.courses.push(course.name);
            calendarEvents.docChanges().forEach((calendarEvent) => {
              if (calendarEvent.type === "added") {
                if (
                  this.upcomingEvents.findIndex(
                    (x) => x.id == calendarEvent.doc.id
                  ) == -1
                ) {
                  let event = this.createEvent(calendarEvent.doc.data());
                  if (event.daysLeft >= 0) {
                    this.upcomingEvents.push(event);
                  }
                }
              }
            });
          })
      );
    },
    fetchCourseInfo() {
      for (const index in this.user.courses) {
        db.collection("courses")
          .doc(this.user.courses[index].course_id)
          .get()
          .then((doc) => {
            this.courseInfo.push({
              courseImage: doc.data().profileImage,
              courseName: this.user.courses[index].name,
              groupDoc: doc.data(),
              groupType: "groups",
              groupID: doc.id,
            });
          });
      }
    },
    fetchGroupInfo() {
      for (const index in this.user.groups) {
        db.collection("groups")
          .doc(this.user.groups[index].group_id)
          .get()
          .then((doc) => {
            this.groupList.push({
              groupImage: doc.data().profileImage,
              groupName: this.user.groups[index].name,
              groupDoc: doc.data(),
              groupType: "groups",
              groupID: doc.id,
            });
          });
      }
    },
    fetchFriendInfo() {
      for (const index in this.user.links) {
        db.collection("users")
          .doc(this.user.links[index])
          .get()
          .then((doc) => {
            if (doc.data()) {
              var filteredArray;
              if (doc.data().links) {
                filteredArray = doc
                  .data()
                  .links.filter((value) => this.user.links.includes(value));
              }
              this.friendInfo.push({
                profileImage: doc.data().profileImage,
                name: doc.data().firstName + " " + doc.data().lastName,
                id: doc.id,
                mutuals: filteredArray.length ? filteredArray.length : 0,
              });
            }
            this.loaded++;
          });
      }
    },
    async setNewGroup() {
      this.$store.commit("messageBoard/setGroupId", this.id);
    },
    getName() {
      return this.courseName.replace(/\s/g, "");
    },
    fetchRequests(requests) {
      if (!requests) {
        return;
      }
      this.linkRequests = [];
      requests.forEach((userDoc) =>
        db
          .collection("users")
          .doc(userDoc.id)
          .get()
          .then((doc) => {
            var user = doc.data();
            user.id = userDoc.id;
            this.linkRequests.push(user);
          })
      );
    },
    startDrag(e, image, index) {
      this.dragImage = image;
      this.dragIndex = index;
    },
    onDrop(e, image, index) {
      this.profile.images.splice(this.dragIndex, 1);
      this.profile.images.splice(index, 0, this.dragImage);
      db.collection("users")
        .doc(firebase.auth().currentUser.uid)
        .update({
          images: this.profile.images,
        });
    },
    checkFriendsAndGroups() {
      var joinedGroup = false;
      var joinedFriend = false;
      if (
        (!this.user.progressBar.joinGroup && this.user.groups.length != 0) ||
        this.user.directMessages.length != 0 ||
        this.user.faculties.length != 0 ||
        this.user.courses.length != 0
      ) {
        joinedGroup = true;
      }
      if (!this.user.progressBar.addFriend && this.user.links.length != 0) {
        joinedFriend = true;
      }

      if (joinedGroup || joinedFriend) {
        db.collection("users")
          .doc(firebase.auth().currentUser.uid)
          .update({
            progressBar: {
              addFriend: joinedFriend,
              bio: this.user.progressBar.bio,
              interests: this.user.progressBar.interests,
              joinGroup: joinedGroup,
              photos: this.user.progressBar.photos,
              profileImage: this.user.progressBar.profileImage,
            },
          });
      }
    },
    setTasks() {
      db.collection("users")
        .doc(this.currentUser.id)
        .get()
        .then((doc) => {
          this.profileImage = doc.data().profileImage;
          if (!doc.data().progressBar.profileImage) {
            this.taskCounter += 1;
            this.hasProfileImg = true;
          }
          this.interests = doc.data().interests;
          if (!doc.data().progressBar.interests) {
            this.taskCounter += 1;
            this.hasInterests = true;
          }
          if (!doc.data().progressBar.bio) {
            this.taskCounter += 1;
            this.hasBio = true;
          }
          if (!doc.data().progressBar.photos) {
            this.taskCounter += 1;
            this.hasImages = true;
          }
          if (!doc.data().progressBar.joinGroup) {
            this.taskCounter += 1;
            this.hasGroups = true;
          }
          if (!doc.data().progressBar.addFriend) {
            this.taskCounter += 1;
            this.hasFriends = true;
          }
          this.createTasks(
            this.hasProfileImg,
            this.hasInterests,
            this.hasBio,
            this.hasImages,
            this.hasGroups,
            this.hasFriends
          );
        });
    },
    createTasks(profileImg, interest, bio, images, groups, friends) {
      let DPtask = {
        image:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FaddDPProgress.png?alt=media&token=11206538-eff2-4d4b-a0a8-345dcee37123",
        title: "Take it and frame it!",
        subTitle:
          "Having a display picture makes your profile so much more fun to look at",
      };
      let interestTask = {
        image:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FaddInterestsProgress.png?alt=media&token=b5cf65a6-cf72-4177-bd0c-958bc24ba252",
        title: "Love something? Share it!",
        subTitle: "With interests you can find likeminded people and groups",
      };
      let bioTask = {
        image:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FaddBioProgress.png?alt=media&token=f94ea09c-c416-4e55-b5b5-b765da7ab3f5",
        title: "Create a bio to tell your life story",
        subTitle: "Use this great opportunity to talk about yourself!",
      };
      let imagesTask = {
        image:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FaddImagesProgress.png?alt=media&token=86ebaaaa-e940-4d7c-ad6a-9e9a5370023f",
        title: "Add profile images to show off who you are",
        subTitle: "Images can help others get to know you better",
      };
      let groupTask = {
        image:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FjoinGroupProgress.png?alt=media&token=4283e362-d372-4247-a358-017faac84643",
        title: "Join or start a conversation",
        subTitle: "Almost done! Join a group and you're good to go",
      };
      let friendTask = {
        image:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/progressImages%2FjoinGroupProgress.png?alt=media&token=4283e362-d372-4247-a358-017faac84643",
        title: "FRIENDS TASK",
        subTitle: "CHANGE THIS ONE",
      };

      if (profileImg) {
        this.tasks.push(DPtask);
      }
      if (interest) {
        this.tasks.push(interestTask);
      }
      if (bio) {
        this.tasks.push(bioTask);
      }
      if (images) {
        this.tasks.push(imagesTask);
      }
      if (groups) {
        this.tasks.push(groupTask);
      }
      if (friends) {
        this.tasks.push(friendTask);
      }
    },
    nextTask(n) {
      this.taskIndex += n;
      if (this.taskIndex >= this.tasks.length) {
        this.taskIndex = 0;
      } else if (this.taskIndex < 0) {
        this.taskIndex = this.tasks.length - 1;
      }
    },
    loadImage() {
      this.imageUrl = this.externalUrl;
      this.image = "";
      var that;
      var highResImage = new Image();
      that = this;
      highResImage.onload = function() {
        that.image = that.imageUrl;
      };
      highResImage.src = this.imageUrl;
    },
  },
};
</script>

<style src="@/styles/views/Profile.css"></style>
